import React from 'react'
import PropTypes from 'prop-types'
import MacStyleCarousel from '../component/MacStyleCarousel/MacStyleCarousel'
import AppStoreComponent from '../component/AppStoreComponent/AppStoreComponent'
import easestarLogo from '../../../assets/logos/easestar.png'
import './AppStoreWindowContent.css'

function AppStoreWindowContent({ onAppClick }) {
  return (
    <div>
      <MacStyleCarousel />
      <div className="appstore-window-content-container">
        <AppStoreComponent
          title="EaseStar"
          description="An innovative social app designed for creators and privacy-conscious users. Share your artwork, photos, and thoughts freely, knowing your content is protected from unwanted downloads or screenshots."
          image={easestarLogo}
          onClick={() => onAppClick('EaseStar')}
        />
      </div>
    </div>
  )
}

AppStoreWindowContent.propTypes = {
  onAppClick: PropTypes.func.isRequired,
}

export default AppStoreWindowContent
